import {ReactComponent as IconImageDefault} from './icon-image-default.svg';
import {ReactComponent as IconAttachedFile} from "./icon-attached-file.svg";
import {ReactComponent as IconLocation} from "./location.svg";
import {ReactComponent as IconBack} from './icon-back.svg';
import {ReactComponent as IconHeart} from './icon-heart.svg';
import {ReactComponent as IconCopy} from './icon-copy.svg';
import {ReactComponent as IconPhone} from './icon-phone.svg';
import {ReactComponent as IconDiscountVoucher} from './discount-voucher-icon.svg';
import { ReactComponent as IconStoreSolid } from './icon-store-solid.svg';
import { ReactComponent as IconIncrease } from './increase.svg';
import { ReactComponent as IconUser } from './icon-user.svg';
import { ReactComponent as IconEye } from './icon-eye.svg';
import { ReactComponent as IconDecrease } from './icon-decrease.svg';
import { ReactComponent as IconShape } from './icon-shape.svg';

const iconCollection = {
    'icon-image-default': IconImageDefault,
    'icon-attached-file': IconAttachedFile,
    'icon-location': IconLocation,
    'icon-back': IconBack,
    'icon-heart': IconHeart,
    'icon-copy': IconCopy,
    'icon-phone': IconPhone,
    'icon-discount-voucher': IconDiscountVoucher,
    'icon-store-solid': IconStoreSolid,
    'icon-increase': IconIncrease,
    'icon-decrease': IconDecrease,
    'icon-user': IconUser,
    'icon-eye': IconEye,
    'icon-shape': IconShape,

}

export default iconCollection;